import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as _ from "underscore"

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  MenuRoutes: any = [

    {title: 'Plateforme D\'Clic'},
    {
      name: "jeunes",
      icon: "chart-pie",
      link: ["/suivitraitementjeunes/aio"],
      label: "Suivi Traitement Jeunes",
      roles:['SUPER_ADMIN']
    },
    {
      name: "jeunes",
      icon: "users",
      link: ["/traitementjeunes"],
      label: "Traitement des jeunes",
      roles:['SUPER_ADMIN','ADMIN_CSP','ADMIN_AIO','ADMIN_CG','ADMIN_PS','ADMIN_IML','ADMIN_IP','ADMIN_PH'],
      childrens:[

      //  {
      //    name: "suivinouveauxinscrits",
      //    link: ["/jeunes/suivinouveauxinscrits"],
      //    label: "Suivi Activités",
      //    roles:['SUPER_ADMIN','ADMIN_CSP'],
      //  },
       {
         name: "traitementaio",
         link: ["/traitementjeunes/aio"],
         label: "Traitement AIO",
         roles:['SUPER_ADMIN','ADMIN_CSP','ADMIN_AIO'],
       },
        {
          name: "traitementcg",
          link: ["/traitementjeunes/cg"],
          label: "Traitement CG",
          roles:['SUPER_ADMIN','ADMIN_CSP','ADMIN_CG'],
        },
        {
          name: "traitementps",
          link: ["/traitementjeunes/ps"],
          label: "Traitement PS",
          roles:['SUPER_ADMIN','ADMIN_CSP','ADMIN_PS'],
        },
        {
          name: "traitementiml",
          link: ["/traitementjeunes/iml"],
          label: "Traitement IML",
          roles:['SUPER_ADMIN','ADMIN_CSP','ADMIN_IML'],
        },
        {
          name: "traitementip",
          link: ["/traitementjeunes/ip"],
          label: "Traitement IP",
          roles:['SUPER_ADMIN','ADMIN_CSP','ADMIN_IP'],
        },
        {
          name: "traitementph",
          link: ["/traitementjeunes/ph"],
          label: "Traitement PH",
          roles:['SUPER_ADMIN','ADMIN_CSP','ADMIN_PH'],
        },
        // {
        //   name: "jeunes1",
        //   link: ["/jeunes/suiviactivites"],
        //   label: "Suivi d'activités",
        // },
        // {
        //   name: "jeunes2",
        //   link: ["/jeunes/listingrappel"],
        //   label: "Listing rappel",
        // },
      ]
    },
    {
      name: "logements",
      icon: "home",
      link: ["/logements"],
      label: "Logements",
      roles:['SUPER_ADMIN','ADMIN_PH'],
      childrens:[
       {
         name: "logements",
         link: ["/logements"],
         label: "Logements",
         roles:['SUPER_ADMIN','ADMIN_PH'],
       },
      ]
    },
    {
      name: "proprietaires",
      customIcon: "fas fa-user-tie",
      link: ["/proprietaires"],
      label: "Propriétaires",
      roles:['SUPER_ADMIN','ADMIN','ADMIN_PROPRIO','ADMIN_PH'],
      childrens: [
        {
          name: "proprietaires",
          link: ["/proprietaires"],
          label: "Propriétaires",
          roles:['SUPER_ADMIN','ADMIN','ADMIN_PROPRIO','ADMIN_PH'],
        },
      ]
    },
    {title: 'Forum D\'Clic',
    roles:['SUPER_ADMIN','ADMIN_FORUM','ADMIN_ACCUEIL_FORUM']

  },
  {
    name: "forum-dashboard",
    link: ["/forum/dashboard"],
    label: "Tableau de bord Forum",
    customIcon: "fa fa-tachometer-alt",
    roles:['SUPER_ADMIN','ADMIN_FORUM'],
  },
  {
    name: "forum-configuration",
    link: ["/forum/configuration"],
    label: "Configurer le Forum",
    customIcon: "fa fa-cogs",
    roles:['SUPER_ADMIN','ADMIN_FORUM'],
  },
  {
    name: "scans",
    link: ["/forum/scans"],
    label: "Accueil et scans",
    customIcon: "fa fa-barcode-read",
    roles:['SUPER_ADMIN','ADMIN_FORUM','ADMIN_ACCUEIL_FORUM'],
  },
      {
        name: "inscriptions",
        link: ["/forum/invitations"],
        label: "Invitations",
        customIcon: "fa fa-users",
        roles:['SUPER_ADMIN','ADMIN_FORUM'],
      },
      {
        name: "inscriptions",
        link: ["/forum/invitations/activites/home_dating"],
        label: "Invitations Home Dating",
        customIcon: "fal fa-comments-alt",
        roles:['SUPER_ADMIN','ADMIN_FORUM'],
      },  {
        name: "inscriptions",
        link: ["/forum/invitations/activites/petitsalon_activites"],
        label: "Invitations Petits Salons",
        customIcon: "fa fa-couch",
        roles:['SUPER_ADMIN','ADMIN_FORUM'],
      },  {
        name: "inscriptions",
        link: ["/forum/invitations/activites/petitsalon_delivrance"],
        label: "Invitations Traitement de la demande",
        customIcon: "fa fa-home",
        roles:['SUPER_ADMIN','ADMIN_FORUM'],
      }, {
        name: "forumsuivi",
        link: ["/forum/suivi"],
        label: "Suivi des inscriptions",
        customIcon: "fa fa-chart-line",
        roles:['SUPER_ADMIN','ADMIN_FORUM'],
      },
        {
          name: "evenements",
          link: ["/forum/evenements"],
          label: "Evenements",
          roles:['SUPER_ADMIN'],
          childrens:[
            {
              name: "evenements",
              link: ["/forum/evenements"],
              label: "Evenements",
              roles:['SUPER_ADMIN'],
            },
            {
              name: "evenementlieux",
              link: ["/forum/evenements/lieux"],
              label: "Evenements Lieux",
              roles:['SUPER_ADMIN'],
            },
            {
              name: "evenementparts",
              link: ["/forum/evenements/parts"],
              label: "Evenements Parts",
              roles:['SUPER_ADMIN'],
            }
          ]
        },
        {
          name: "tableinscriptions",
          link: ["/forum/tableinscriptions"],
          label: "inscriptions (base de donnee)",
          roles:['SUPER_ADMIN'],
        },
        {
          name: "scans",
          link: ["/forum/scans/details"],
          label: "scans (base de donnee)",
          roles:['SUPER_ADMIN'],
        },
        {
          name: "offres",
          link: ["/forum/offres"],
          label: "offres",
          roles:['SUPER_ADMIN'],
          childrens:[
            {
              name: "offres",
              link: ["/forum/offres"],
              label: "offres",
            },
          ]
        },
   // {
   //   name: "proprietaires",
   //   link: ["/proprietaires"],
   //   label: "Proprietaires",
   //   roles:['SUPER_ADMIN'],
   //   childrens:[

   //     {
   //       name: "proprietaires",
   //       link: ["/proprietaires"],
   //       label: "proprietaires",
   //     },
   //   ]
   // },

   {title: 'Administration',
   roles:['SUPER_ADMIN']},


   {
    name: "settings",
    icon: "wrench",
    link: ["/settings"],
    label: "Settings",
    roles:['SUPER_ADMIN'],
  },
  {
    name: "api-comparison",
    customIcon: "fas fa-exchange-alt",
    link: ["/api-comparison"],
    label: "API Comparison",
    roles:['SUPER_ADMIN'],
  },
  {
    name: "instagram",
    customIcon: "fab fa-instagram",
    link: ["/instagram"],
    label: "Instagram",
    roles:['SUPER_ADMIN'],
  },

  {
    name: "demandes",
    icon: "pencil-square",
    link: ["/crud/demandes"],
    label: "Demandes",
    roles:['SUPER_ADMIN'],
  },
  {
    name: "annonces",
    icon: "pencil-square",
    link: ["/crud/annonces"],
    label: "Annonces",
    roles:['SUPER_ADMIN'],
  },
  {
    name: "commentaires",
    icon: "pencil",
    link: ["/crud/commentaires"],
    label: "Commentaires",
    roles:['SUPER_ADMIN'],
  },

  {
    name: "commentairetypes",
    icon: "pencil",
    link: ["/crud/commentairetypes"],
    label: "Commentaires Types",
    roles:['SUPER_ADMIN'],
  },

  {
    name: "contenus",
    icon: "pencil",
    link: ["/crud/contenus"],
    label: "Contenus",
    roles:['SUPER_ADMIN'],
  },

  {
    name: "contenutypes",
    icon: "pencil",
    link: ["/crud/contenutypes"],
    label: "Contenus Types",
    roles:['SUPER_ADMIN'],
  },


  {
    name: "traitementstatuts",
    icon: "pencil",
    link: ["/crud/traitementstatuts"],
    label: "Traitements Statuts",
    roles:['SUPER_ADMIN'],
  },

   {
     name: "users",
     icon: "users",
     link: ["/users"],
     label: "Users",
     roles:['SUPER_ADMIN'],
     childrens:[

       {
         name: "users",
         link: ["/users"],
         label: "Users",
         roles:['SUPER_ADMIN'],
       },
       {
         name: "fonctions",
         link: ["/fonctions"],
         label: "fonctions",
         roles:['SUPER_ADMIN'],
       },
       {
         name: "roles",
         link: ["/roles"],
         label: "Roles",
         roles:['SUPER_ADMIN'],
       },

       {
         name: "usersroles",
         link: ["/users/roles"],
         label: "Users Roles",
         roles:['SUPER_ADMIN'],
       },

     ]
   },
   {
     name: "mailtemplates",
     icon: "at-symbol",
     link: ["/mailtemplates"],
     label: "Mail Templates",
     roles:['SUPER_ADMIN'],
   },
   {
    name: "smstemplates",
    icon: "chat-bubble-oval-left",
    link: ["/smstemplates"],
    label: "Sms Templates",
    roles:['SUPER_ADMIN'],
  },
  {
    name: "test-emails",
    icon: "envelope-open",
    link: ["/test-emails"],
    label: "Test Emails",
    roles:['SUPER_ADMIN'],
  },
];
  constructor() { this.addPrefix(this.MenuRoutes); }

  addPrefix(routes){
  _.each(routes, (route) => {
      route.link = [ (environment.adminOnly ?  '' :  '/dashboard') + route.link]
      if(route.childrens) this.addPrefix(route.childrens)
    });
  }

  getMenu(){

    return this.MenuRoutes;
  }
}
